<script>
  import i18n from "@/lib/i18n";
  $: t = $i18n.getFixedT(null, null, "socialProof");

  $: testimonials = [
    {
      name: "anonymous",
      text: t("text1"),
      stars: 5,
    },
    {
      name: "anonymous",
      text: t("text2"),
      stars: 5,
    },
    {
      name: "anonymous",
      text: "How can such a simple tool be this powerful? feels wrong...",
      stars: 5,
    },
    {
      name: "anonymous",
      text: "I have this extensive colleciton of links that I saved over the years, and about 50% or so stoped working after a while. I knew looking for them is very time intensive so i looked for alternatives and voila: Everymov comes along. And it worked better than expected. 5 stars.",
      stars: 5,
    },
    {
      name: "anonymous",
      text: "Found a piece I haven't seen in 15 years. On a random a$$ site I would have never found by myself. It really works 9 out of 10 times.",
      stars: 5,
    },
  ];
</script>

<main class="flex flex-1 text-white px-4 py-8 items-center bg-black">
  <div class="container mx-auto max-w-6xl text-center">
    <!-- Header Section -->
    <div class="mb-12">
      <h2 class="text-4xl font-bold mb-4 pt-16">What Our Users Say</h2>
    </div>

    <!-- Testimonials Grid -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
      {#each testimonials as testimonial}
        <div class="p-6">
          <!-- Stars -->
          <div class="mb-2">{"⭐".repeat(testimonial.stars)}</div>
          <!-- Testimonial Text -->
          <p class="text-gray-400 text-xl mb-3 italic">"{testimonial.text}"</p>

          <!-- Author Info -->
          <div class="mt-auto">
            <p class="text-sm text-gray-500">— {testimonial.name}</p>
          </div>
        </div>
      {/each}
    </div>
  </div>
</main>
